import {Component, Input, Output, EventEmitter, OnInit, SimpleChanges, OnChanges} from '@angular/core';
import {PopupService} from "../../../../services/popup.service";
import {animate, style, transition, trigger} from "@angular/animations";
import {Observable} from "rxjs";
import {ReportState} from "../../../../state/report/report.reducer";
import {Store} from "@ngrx/store";
import {selectReport} from "../../../../state/search/search.selectors";
import {Company} from "../../../../interfaces/company.interface";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-person-expanded',
  templateUrl: './person-expanded.component.html',
  styleUrls: ['./person-expanded.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }), // start with translateY -100%
        animate('1s ease-out', style({ transform: 'translateY(0)' })) // animate to translateY 0 over 1 second with ease-out timing
      ]),
    ]),
  ],
})
export class PersonExpandedComponent implements OnInit {

  @Input() reportSearch: any;
  @Input() report: any;
  @Input() company: Company;

  // @Input() personal_background: InnerHTML;
  // prospect_insights: string;
  assistantPrompts = [];

  personalBackground: SafeHtml | string = 'N/A';

  emailsCount: number = 0;
  phoneNumbersCount: number = 0;

  isImageError = false;



  constructor(
    private popupService: PopupService,
    private store: Store<{ reportSearch: ReportState }>,
    private sanitizer: DomSanitizer
  ) { }

  @Output() dataEmitter = new EventEmitter<any>();
  @Output() editPromptToggled = new EventEmitter<{ visible: boolean, assistantPrompt: string, promptValue: InnerHTML }>();

  // Define an observable for the report data
  report$: Observable<any>;

  ngOnInit() {

    // console.log('[PersonExpanded] ngOnInit() - @Input() report data:', this.report);

    // nullish coalescing operator (??)
    // optional chaining (?.)

    this.countEmails();
    this.countPhoneNumbers();

    this.store.select(selectReport).subscribe(report => {
      if (report) {

        // this.assistantPrompts = report.report?.assistant_prompts

        /*
        const personal_background = this.getAssistantPromptByTag('ASK_ASSISTANT_PERSONAL_BACKGROUND')
        if (personal_background) {
          this.generatePersonalBackground(personal_background)
        } else {
          console.log('Personal background was not found.');
          // if(this.prospect_insights)
          //   this.personal_background = this.prospect_insights.split(".")[0] + "."
        }
        */

      }
    });

  }

  /**
   * Called when input properties change.
   * Updates the personal background content based on the company input.
   *
   * @param changes SimpleChanges - Object containing changed inputs.
   */
  /*
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['company'] && changes['company'].currentValue) {
      this.updatePersonalBackground();
    }
  }
  */

  /**
   * Updates the `personalBackground` variable with sanitized HTML content.
   */
  /*
  private updatePersonalBackground(): void {
    const prompt = this.company?.assistant_prompts?.find(p => p.tag === 'ASK_ASSISTANT_PERSONAL_BACKGROUND');

    if (!prompt || !prompt.content) {
      this.personalBackground = 'N/A';
      return;
    }

    try {
      // Parse the JSON content
      const parsedContent = JSON.parse(prompt.content);

      // Ensure the content has a valid 'description' field
      if (parsedContent && parsedContent.description) {
        this.personalBackground = this.sanitizer.bypassSecurityTrustHtml(parsedContent.description);
      } else {
        this.personalBackground = 'N/A';
      }
    } catch (error) {
      console.error('Failed to parse personal background content:', error);
      this.personalBackground = 'N/A';
    }
  }
  */

  /*
  getAssistantPromptByTag(tag: string): object | null {
    const foundObject = this.assistantPrompts.find(obj => obj.tag.includes(tag));
    return foundObject || null;
  }

  generatePersonalBackground(personalBackground: any): void {
    try {
      this.personal_background = personalBackground.response.message.content
    } catch (error) {
      console.error("[generatePersonalBackground] Failed to parse JSON", error);
      // if(this.prospect_insights)
      //   this.personal_background = this.prospect_insights.split('.')[0] + '.';
    }
  }
  */

  expandPerson(personExpanded: boolean) {
    this.dataEmitter.emit(!personExpanded);
  }

  descriptionPopup(): void {
    if (this.personalBackground) {
      // Extract the raw HTML string from the SafeHtml object
      const rawHtml = this.personalBackground instanceof Object
        ? this.personalBackground['changingThisBreaksApplicationSecurity'] || 'N/A'
        : this.personalBackground;

      this.popupService.info('Description', rawHtml);
    }
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'https://ui-avatars.com/api/?background=FFA500&color=fff&rounded=true&name='+this.reportSearch.name+'&format=svg&size=128'; //'assets/images/human.svg' // Fallback image when error occurs
    this.isImageError = true;
  }

  countEmails(){
    const emails = [this.reportSearch.email,this.reportSearch.search_person.enhanced_data?.email]

    // remove duplicates
    const uniqueEmails = Array.from(new Set(emails)).filter(value => value !== "" && value !=null)

    this.emailsCount = uniqueEmails.length
  }

  countPhoneNumbers() {
    const phoneNumbers = this.reportSearch.search_person.enhanced_data?.phone_numbers

    // remove duplicates
    const uniquePhoneNumbers = Array.from(new Set(phoneNumbers)).filter(value => value !== "" && value !=null)

    this.phoneNumbersCount = uniquePhoneNumbers.length
  }

  handleEditPrompt(assistantPrompt: string, promptValue: InnerHTML) {
    this.editPromptToggled.emit({
      visible: true,              // Show the modal
      assistantPrompt: assistantPrompt,
      promptValue: promptValue
    });
  }

  showImagePopup(imageUrl: string): void {
    // Only open the popup if there was no error loading the image
    if (!this.isImageError) {
      this.popupService.info('Profile Image', `<img src="${imageUrl}" class="w-full h-full object-cover rounded-md" />`);
    }
  }

  onImageLoad(): void {
    // Reset the error state if the image loads successfully
    this.isImageError = false;
  }

}
